import locale from '@locales/locale.json';

export default locale;
